export default __webpack_public_path__ + "src/assets/recognified_logo.png";